import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Rx";
import {global} from "../../environments/global";
import {HttpProvider} from "../http/http";

/*
  Generated class for the LinkProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LinkProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello LinkProvider Provider');
  }

  getShareList(page, pagesize) {
    return this.http.hPost('/sharetask/get_list', {page: page, pagesize: pagesize});
  }

  createShareLink(share) {
    let url = share.share_task_id?'/sharetask/modify':'/sharetask/create';
    return this.http.hPost(url, share);
  }

  upload(file: File): Observable<string | number> {

    let fd: FormData = new FormData();

    fd.append("file", file);
    fd.append('token', localStorage.getItem(global.token_name));

    return this.http.hPost('/sharetask/upload_oss', fd, 60000*2);
  }

  getStatisticList(id, page, pagesize, order) {
    let params = {
      task_id: id,
      page: page,
      pagesize: pagesize,
      order_by: order + 1
    };
    return this.http.hPost('/sharetask/get_statistic', params);
  }

  getUrlInfo(url){
    return this.http.hPost('/sharetask/get_url_info',{url:url});
  }

  deleteOneShare(share_task_id,page,pagesize){
    let params = {
      share_task_id:share_task_id,
      page:page,
      pagesize:pagesize
    };

    return this.http.hPost('/sharetask/delete',params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/link/link.ts